import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useAuth } from './contexts/AuthContext';
import { Toaster } from './components/common/Toaster';
import { GDPRPopup } from './components/common/GDPRPopup';

// Pages
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import QRGenerator from './pages/QRGenerator';
import Analytics from './pages/Analytics';
import Workspaces from './pages/Workspaces';
import TeamMembers from './pages/TeamMembers';
import CustomDomains from './pages/CustomDomains';
import FileManager from './pages/FileManager';
import Settings from './pages/Settings';
import AdminPanel from './pages/AdminPanel';
import LandingPageBuilder from './pages/LandingPageBuilder';
import QRScanner from './pages/QRScanner';

// Layout
import AppLayout from './components/layout/AppLayout';
import AdminLayout from './components/layout/AdminLayout';

function App() {
  const { user, loading } = useAuth();

  // Show loading spinner while checking auth status
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <AnimatePresence mode="wait">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={!user ? <LandingPage /> : <Navigate to="/dashboard" replace />} />
          <Route path="/auth" element={!user ? <AuthPage /> : <Navigate to="/dashboard" replace />} />
          <Route path="/scan/:id" element={<QRScanner />} />
          
          {/* Admin Panel - Protected Route */}
          <Route 
            path="/admin" 
            element={
              user && user.role === 'admin' ? (
                <AdminLayout>
                  <AdminPanel />
                </AdminLayout>
              ) : user ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <Navigate to="/auth" replace />
              )
            } 
          />
          
          {/* Protected Routes */}
          <Route 
            path="/dashboard" 
            element={user ? <AppLayout><Dashboard /></AppLayout> : <Navigate to="/auth" replace />} 
          />
          <Route 
            path="/generate" 
            element={user ? <AppLayout><QRGenerator /></AppLayout> : <Navigate to="/auth" replace />} 
          />
          <Route 
            path="/analytics" 
            element={user ? <AppLayout><Analytics /></AppLayout> : <Navigate to="/auth" replace />} 
          />
          <Route 
            path="/workspaces" 
            element={user ? <AppLayout><Workspaces /></AppLayout> : <Navigate to="/auth" replace />} 
          />
          <Route 
            path="/team" 
            element={user ? <AppLayout><TeamMembers /></AppLayout> : <Navigate to="/auth" replace />} 
          />
          <Route 
            path="/domains" 
            element={user ? <AppLayout><CustomDomains /></AppLayout> : <Navigate to="/auth" replace />} 
          />
          <Route 
            path="/files" 
            element={user ? <AppLayout><FileManager /></AppLayout> : <Navigate to="/auth" replace />} 
          />
          <Route 
            path="/settings" 
            element={user ? <AppLayout><Settings /></AppLayout> : <Navigate to="/auth" replace />} 
          />
          <Route 
            path="/builder/:id" 
            element={user ? <AppLayout><LandingPageBuilder /></AppLayout> : <Navigate to="/auth" replace />} 
          />
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to={user ? "/dashboard" : "/"} replace />} />
        </Routes>
      </AnimatePresence>
      <Toaster />
      <GDPRPopup />
    </div>
  );
}

export default App;